export default {"src":"/_next/static/media/pistachios.a981d4a6.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};